import React, { useCallback, useEffect } from 'react';
import styles from './retailMomo.module.scss';
import { Switch, Route, RouteComponentProps, Redirect } from 'react-router';
import { RetailMomoProps } from './RetailMomoModel';
import { Products } from './Products/Products';

import RouteWithPermission from 'components/RouteWithPermission/RouteWithPermission';
import { RoleNames } from 'core';
import { notRoles } from 'core/permission/PermissionDSL';
import { ROUTE_PATH } from 'enum/RoutePath';
import { withErrorBoundary } from 'hoc/withErrorBoundary';
import { ERROR_CODE } from 'core/ErrorCode';
import { useProductStore } from 'store/productStore';

const ProductsView = withErrorBoundary(ERROR_CODE.PRODUCT_CATEGORY, Products);
export function RetailMomo(props: RouteComponentProps<{}> & RetailMomoProps) {
  const { mainPagePath } = props;
  const { resetProductStore } = useProductStore();

  const renderProducts = useCallback(
    () => (
      <div className={styles.container}>
        <ProductsView />
      </div>
    ),
    [],
  );

  const redirectToRoot = useCallback(
    () => <Redirect to={mainPagePath} />,
    [mainPagePath],
  );

  const { sysAdmin, adsReport } = RoleNames;

  useEffect(() => {
    resetProductStore();
  }, [renderProducts]);

  return (
    <div className={styles.retailMomo}>
      <Switch>
        <RouteWithPermission
          path='/products'
          permissionAware={notRoles(sysAdmin, adsReport)}
          redirectPath={`/products/${ROUTE_PATH.ERROR403}`}
          render={renderProducts}
        />
        <Route render={redirectToRoot} />
      </Switch>
    </div>
  );
}
